// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__ZMuVr","OpenPrize":"Modal_OpenPrize__3hLS0","openPrize":"Modal_openPrize__-hpmC"};